document.addEventListener('DOMContentLoaded', function () {
  // Select search input and results container
  const input = document.querySelector('input[type="search"]');
  const container = document.getElementById('SearchResultsContainer');

  // Initialize state variables for debounce, abort, search term, and pagination
  let debounceTimer;
  let abortController;
  let lastSearchTerm = '';
  let currentPage = 1;

  // Exit if essential elements are missing
  if (!input || !container) return;

  // Function to fetch and render predictive search results
  function fetchResults(page = 1) {
    currentPage = page;
    const term = input.value.trim();

    // Hide container if search term is too short
    if (term.length < 3) {
      container.hidden = true;
      return;
    }

    // Cancel previous fetch if still running
    if (abortController) abortController.abort();
    abortController = new AbortController();

    // Build product search URL with query and pagination
    const productParams = new URLSearchParams({
      q: term,
      type: 'product',
      section_id: 'predictive-search',
      page,
    });

    // Collect filters from desktop and mobile forms
    const forms = [document.querySelector('#FacetFiltersForm'), document.querySelector('#FacetFiltersFormMobile')];
    forms.forEach((form) => {
      if (!form) return;
      const formData = new FormData(form);
      for (const [key, value] of formData.entries()) {
        if (!value) continue; // Skip empty values
        if (productParams.has(key)) productParams.delete(key); // Remove duplicates
        productParams.append(key, value); // Append filter parameter
      }
    });

    // Append currently selected sort_by value if exists
    const sortRadio = document.querySelector('input[name="sort_by"]:checked');
    if (sortRadio) {
      if (productParams.has('sort_by')) productParams.delete('sort_by');
      productParams.append('sort_by', sortRadio.value);
    }

    const productURL = `/search?${productParams.toString()}`;

    // Build pages and articles search URL
    const contentParams = new URLSearchParams({
      q: term,
      type: 'page,article',
      section_id: 'predictive-search-page',
    });
    const contentURL = `/search?${contentParams.toString()}`;

    // Fetch products and content in parallel
    Promise.all([
      fetch(productURL, { signal: abortController.signal }).then((r) => r.text()),
      fetch(contentURL, { signal: abortController.signal }).then((r) => r.text()),
    ])
      .then(([productHTML, contentHTML]) => {
        const productDoc = new DOMParser().parseFromString(productHTML, 'text/html');
        const contentDoc = new DOMParser().parseFromString(contentHTML, 'text/html');

        const productSection = productDoc.querySelector('#shopify-section-predictive-search');
        const contentSection = contentDoc.querySelector('#shopify-section-predictive-search-page');

        // Hide container if no product results
        if (!productSection) {
          container.hidden = true;
          return;
        }

        // Extract product, pagination, pages, and articles sections
        const newProducts = productSection.querySelector('.search-results-section--products');
        const newPagination = productSection.querySelector('.collection__pagination');
        const pages = contentSection?.querySelector('.search-results-section--pages');
        const articles = contentSection?.querySelector('.search-results-section--articles');

        // Replace container content on first load
        if (!container.innerHTML.trim()) {
          container.innerHTML = productSection.innerHTML;
        } else {
          const existingProducts = container.querySelector('.search-results-section--products');
          const existingPagination = container.querySelector('.collection__pagination');

          // Update pagination section
          if (newPagination && existingPagination) {
            existingPagination.replaceWith(newPagination.cloneNode(true));
          } else if (newPagination && !existingPagination && existingProducts) {
            existingProducts.after(newPagination.cloneNode(true));
          } else if (!newPagination && existingPagination) {
            existingPagination.remove();
          }

          // Update products section
          if (existingProducts && newProducts) {
            existingProducts.replaceWith(newProducts.cloneNode(true));
          }
        }

        // Append pages and articles if not already present
        if (pages && !container.querySelector('.search-results-section--pages')) {
          container.append(pages.cloneNode(true));
        }
        if (articles && !container.querySelector('.search-results-section--articles')) {
          container.append(articles.cloneNode(true));
        }

        // Show container and update last search term
        container.hidden = false;
        lastSearchTerm = term;
        scrollToTop();
      })
      .catch((err) => {
        // Hide container on real fetch errors
        if (err.name !== 'AbortError') container.hidden = true;
      });
  }

  // Debounce search input
  input.addEventListener('input', function () {
    const term = input.value.trim();
    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(() => {
      // Reset container and pagination if search term changed
      if (term !== lastSearchTerm) {
        lastSearchTerm = term;
        currentPage = 1;
        container.innerHTML = '';
      }
      fetchResults();
    }, 300);
  });

  // Handle filter and sort changes
  document.addEventListener('change', function (event) {
    const control = event.target.closest('[name]');
    if (!control || !container.contains(control)) return;

    const name = control.name;

    // Only trigger fetch if filter or sort changed
    if (name.startsWith('filter.') || name === 'sort_by') {
      currentPage = 1;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => fetchResults(currentPage), 300);
    }
  });

  // Handle pagination clicks
  document.addEventListener('click', function (event) {
    const link = event.target.closest('.pagination a');
    if (!link || !container.contains(link)) return;

    event.preventDefault();
    const url = new URL(link.href);
    const page = Number(url.searchParams.get('page')) || 1;

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => fetchResults(page), 100);
  });

  // Scroll to top smoothly
  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // Auto-run search if URL has query parameter
  const urlParams = new URLSearchParams(window.location.search);
  const initialQuery = urlParams.get('q');
  if (initialQuery) {
    input.value = initialQuery;
    currentPage = Number(urlParams.get('page')) || 1;
    fetchResults(currentPage);
  }

  // Mobile facet form handling
  const mobileForm = document.querySelector('#FacetFiltersFormMobile');
  if (!mobileForm) return;

  // Trigger change event for radio/checkbox inputs
  mobileForm.addEventListener('change', (event) => {
    const input = event.target;
    if (input.matches('input[type="radio"], input[type="checkbox"]')) {
      input.closest('form').dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // Trigger change event for Apply buttons
  const applyButtons = mobileForm.querySelectorAll('button, a');
  applyButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      mobileForm.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
});
